(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cp-shirt-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-size-guide')) {
    customElements.define('cp-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const cells = Array.from(this.querySelectorAll('tbody td'));
        if (!cells.length || cells.some(cell => !/^\d+(\.\d+)?$/.test(cell.textContent.trim()))) return;
        cells.forEach(cell => { cell.dataset.inches = cell.textContent.trim(); });
        this.querySelector('.cp-size-guide__units').hidden = false;
        this.dataset.ready = 'true';
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-unit]');
          if (!button || !this.contains(button)) return;
          const unit = button.dataset.unit;
          cells.forEach(cell => {
            cell.textContent = unit === 'cm' ? (Number(cell.dataset.inches) * 2.54).toFixed(2) : cell.dataset.inches;
          });
          this.querySelectorAll('button[data-unit]').forEach(control => {
            control.setAttribute('aria-pressed', String(control.dataset.unit === unit));
          });
          const label = this.querySelector(unit === 'cm' ? '[data-centimeters-label]' : '[data-inches-label]');
          this.querySelector('[data-unit-label]').textContent = label.textContent;
          this.querySelector('[data-chart-caption]').textContent = this.querySelector('[data-chart-title]').textContent + ' — ' + label.textContent;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
